import * as React from "react";
import { useRef, useState } from "react";
import { ComposerModels } from "../../../types";
import { useDismiss } from "../../../hooks/useDismiss";
import { ChevronDown, Check } from "../../icons";
import styles from "./ModelMenu.module.css";

interface Props {
	models: ComposerModels;
}

export const ModelMenu: React.FC<Props> = ({ models }) => {
	const [open, setOpen] = useState(false);
	const rootRef = useRef<HTMLDivElement>(null);
	const current = models.options.find((o) => o.id === models.value);
	useDismiss(open, rootRef, () => setOpen(false));

	const pick = (id: string) => {
		setOpen(false);
		models.onChange(id);
	};

	return (
		<div className={styles.root} ref={rootRef}>
			<button
				type="button"
				className={styles.trigger}
				aria-haspopup="menu"
				aria-expanded={open}
				aria-label="Model"
				onClick={() => setOpen((o) => !o)}
			>
				<span>{current?.label ?? models.value}</span>
				<ChevronDown />
			</button>
			{open && (
				<div className={styles.menu} role="menu">
					{models.options.map((o) => (
						<button
							key={o.id}
							type="button"
							role="menuitemradio"
							aria-checked={o.id === models.value}
							className={styles.item}
							onClick={() => pick(o.id)}
						>
							<span className={styles.check}>{o.id === models.value && <Check />}</span>
							<span className={styles.text}>
								<span className={styles.label}>{o.label}</span>
								{o.description && <span className={styles.desc}>{o.description}</span>}
							</span>
						</button>
					))}
				</div>
			)}
		</div>
	);
};
